import { useRef, useState } from "react";
import { Card } from "primereact/card";
import TemplateDemo from "../TopBar/TopBar";
import { InputText } from "primereact/inputtext";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { useMutation } from "@tanstack/react-query";
import { Toast } from "primereact/toast";
import "./Login.css";
import { authLogin } from "../services/auth";
import { getRouteForRole } from "../constants";
import { Checkbox } from "primereact/checkbox";

/**
 * User login form
 */
export default function Login() {
  // Form state
  const queryClient = useQueryClient();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordMode, setPasswordMode] = useState("password");
  const [termsAccepted, setTermsAccepted] = useState(
    localStorage.getItem("termsAccepted") === "true"
  );
  const [contractAccepted, setContractAccepted] = useState(
    localStorage.getItem("contractAccepted") === "true"
  );

  const toastRef = useRef(null);

  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationFn: authLogin,
    onSuccess: (response) => {
      if (response.type === "success") {
        const data = response.data;
        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.user.role);
        localStorage.setItem("isAdmin", data.user.is_superuser);
        localStorage.setItem("username", data.user.username);
        localStorage.setItem("first_name", data.user.first_name);
        localStorage.setItem("termsAccepted", "true");
        localStorage.setItem("contractAccepted", "true");
        const route = getRouteForRole(data.user.role);
        queryClient.invalidateQueries({ queryKey: ["insurance"] });
        navigate(route);
        // if (data.user.role === UserRole.MEDICAL_CENTER) {
        //   navigate('/anticipos');
        // } else {
        //   navigate('/casos');
        // }
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message,
        });
      }
    },
    onError: (error) => {
      console.error("Error fetching login", error);
      toastRef.current.show({
        severity: "error",
        summary: "Error",
        detail: "Ocurrió un error",
      });
    },
  });

  const handleLogin = (e) => {
    e.preventDefault();
    if (!termsAccepted) {
      toastRef.current.show({
        severity: "error",
        summary: "Error",
        detail: "Debes aceptar los términos y condiciones",
      });
      return;
    }
    if (!contractAccepted) {
      toastRef.current.show({
        severity: "error",
        summary: "Error",
        detail: "Debes aceptar los términos del contrato",
      });
      return;
    }
    loginMutation.mutate({ username: email, password });
  };

  return (
    <>
      <TemplateDemo />
      <Toast ref={toastRef} position="top-center" />
      <div className="login-container">
        <Card>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              alt="logo"
              src="/logo.png"
              height="60"
              className="hidden md:block mr-2"
            ></img>
          </div>
          <h2 className="login-title text-center">
            Bienvenido al futuro de la salud{" "}
          </h2>

          <form className="p-fluid" onSubmit={handleLogin}>
            <div className="p-field">
              <label htmlFor="email">Correo</label>
              <InputText
                id="email"
                name="email"
                type="email"
                value={email}
                keyfilter="email"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="p-field">
              <label htmlFor="password">Contraseña</label>
              <div className="p-inputgroup flex-1">
                <InputText
                  id="password"
                  name="password"
                  type={passwordMode}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Button
                  icon={
                    passwordMode === "password"
                      ? "pi pi-eye"
                      : "pi pi-eye-slash"
                  }
                  className="p-inputgroup-addon border-1 border-left-none border-300"
                  text
                  type="button"
                  severity="secondary"
                  onClick={() => {
                    if (passwordMode === "password") {
                      setPasswordMode("text");
                    } else {
                      setPasswordMode("password");
                    }
                  }}
                />
              </div>
            </div>
            <div className="p-field flex gap-2 align-items-top my-1">
              <Checkbox
                inputId="terms"
                onChange={(e) => setTermsAccepted(e.checked)}
                checked={termsAccepted}
              />
              <label htmlFor="terms">
                Acepto los{" "}
                <a
                  href="/terminos-y-condiciones"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Términos y Condiciones
                </a>{" "}
                de esta plataforma
              </label>
            </div>
            <div className="p-field flex gap-2 align-items-top">
              <Checkbox
                inputId="contract"
                onChange={(e) => setContractAccepted(e.checked)}
                checked={contractAccepted}
              />
              <label htmlFor="contract">
                Acepto las{" "}
                <a
                  href="/politicas-de-privacidad"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Políticas de Privacidad
                </a>{" "}
                de esta plataforma.
              </label>
            </div>
            <Button
              type="submit"
              label="Ingresar"
              disabled={loginMutation.isPending}
              loading={loginMutation.isPending}
            />
          </form>
        </Card>
      </div>
    </>
  );
}
